import React from 'react';
import {HashRouter as Router,Routes,Route} from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import OurWorkPage from './pages/OurWorkPage';
import ImpactPage from './pages/ImpactPage';
import GetInvolvedPage from './pages/GetInvolvedPage';
import CSRPage from './pages/CSRPage';
import ContactPage from './pages/ContactPage';
import CrowdfundingPage from './pages/CrowdfundingPage';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/our-work" element={<OurWorkPage />} />
            <Route path="/impact" element={<ImpactPage />} />
            <Route path="/get-involved" element={<GetInvolvedPage />} />
            <Route path="/csr" element={<CSRPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/crowdfunding" element={<CrowdfundingPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;